import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { CurrentUserService } from '../services/current-user.service';
import { IUser } from "src/app/admin/users/models/IUser";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private user: AuthService, private currentUserService: CurrentUserService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!this.user.isLoggedIn()) {
      this.router.navigate(["/account/login"]);
      return false;
    }
    if (route.data.exemptionPaths !== null && route.data.exemptionPaths !== undefined &&
      route.data.exemptionPaths.some(v => state.url.includes(v))) {
      return true;
    }

    if (route.data.roles) {
      const userRoles = this.user.getUserRoles();
      if (route.data.roles.filter(v => userRoles.includes(v)).length === 0) {
        this.router.navigate(['/']);
        return false;
      }
    }
    return true;
  }
}
